module.exports = __webpack_public_path__ + "static/text-de1cb0c8c0cf192d6fabeac47c74ade1.png";